import {
  PageGen,
  PdfRect,
  PdfUnit,
  PdfBrush,
  PdfColor,
  PdfPen,
  PdfPoint,
  ETextAlign,
} from '../pdf/pdf';
import { GUtil } from '../pdf/gutil';
import { IColorSchema } from './colorSchema';

export class ColorSchemaNotebook implements IColorSchema {
  readonly name = 'Notebook';

  private sizeTopHeader = PdfUnit.FromMillimeters(10);
  private sizeTopTitle = PdfUnit.FromMillimeters(8);
  private leftMarginWidth = PdfUnit.FromMillimeters(12);
  private marginTop = PdfUnit.FromMillimeters(5);
  private paddingTop = PdfUnit.FromMillimeters(3);

  private paperColor = PdfColor.fromRgb(255, 255, 250);
  private marginLineColor = PdfColor.fromRgb(255, 100, 100); // Red margin line
  private gridLineColor = PdfColor.fromRgb(200, 230, 255); // Light blue grid

  drawPage(page: PageGen, rect: PdfRect, inner: PdfRect, pageNumber: number): void {
    // Paper background
    page.drawRectangle(null, new PdfBrush(this.paperColor), rect);

    // Draw vertical margin line
    const marginX = rect.x + this.leftMarginWidth;
    page.drawLine(
      new PdfPen(this.marginLineColor, 0.8),
      new PdfPoint(marginX, rect.top),
      new PdfPoint(marginX, rect.bottom)
    );

    const bottomRect = new PdfRect(0, inner.bottom, rect.width, rect.height - inner.bottom);
    page.drawString(
      `${pageNumber}`,
      GUtil.exerciseFont,
      PdfBrush.Black,
      null,
      bottomRect,
      ETextAlign.Center
    );
  }

  drawWindow(page: PageGen, rect: PdfRect, _index: number, counter?: string, title?: string): void {
    const font = GUtil.exerciseFont;
    const top = (this.sizeTopHeader - this.sizeTopTitle) / 2;

    // Red line for the header
    page.drawLine(
      new PdfPen(this.marginLineColor, 0.5),
      new PdfPoint(rect.left + this.leftMarginWidth, rect.y + this.sizeTopHeader),
      new PdfPoint(rect.right, rect.y + this.sizeTopHeader)
    );

    if (counter) {
      // Counter placed in the left margin area
      const rCounter = new PdfRect(rect.x, rect.y + top, this.leftMarginWidth, this.sizeTopTitle);
      page.drawString(`${counter  })`, font, PdfBrush.Black, null, rCounter, ETextAlign.Center);
    }

    if (title) {
      const left = rect.x + this.leftMarginWidth + this.marginTop;
      const s1 = page.measureString(title, font);
      const r = new PdfRect(left, rect.y + top, 2 * this.paddingTop + s1.width, this.sizeTopTitle);
      page.drawString(title, font, PdfBrush.Black, null, r, ETextAlign.CenterLeft);
    }
  }

  drawResult(page: PageGen, rect: PdfRect): void {
    // Light gray background for results to distinguish from "paper"
    page.drawRectangle(null, new PdfBrush(PdfColor.fromRgb(240, 240, 240)), rect);
  }

  calcContent(rect: PdfRect): PdfRect {
    // Content is indented to the right of the vertical margin line
    return new PdfRect(
      rect.x + this.leftMarginWidth + PdfUnit.FromMillimeters(2),
      rect.y + this.sizeTopHeader + PdfUnit.FromMillimeters(2),
      rect.width - this.leftMarginWidth - PdfUnit.FromMillimeters(4),
      rect.height - this.sizeTopHeader - PdfUnit.FromMillimeters(4)
    );
  }
}
